module.exports = __webpack_public_path__ + "bad5dec0c646fc3aa5e39c2ad03fba64.png";